import React from 'react'
import lang from '@/lang'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

import { dateAsReadable } from '@/utils/date'

const useStyles = makeStyles(() => (
  {
    root: {
      display: 'flex',
      flexDirection: 'row',
      height: '110px',
      alignItems: 'center',
      padding: '0 64px 0 57px',
    },
    cell: {
      overflow: 'hidden',
      '&:first-child': {
        paddingRight: '10px',
      },
      '&:last-child': {
        marginLeft: 'auto',
        textAlign: 'right',
        width: '100px',
      },
    },
    label: {
      textTransform: 'uppercase',
      fontSize: '13px',
      letterSpacing: '0.2px',
      color: '#757474',
    },
    text: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '13px',
      letterSpacing: '0.2px',
      color: '#1b1a1a',
      margin: '12px 0',
    },
  }
))

const RecieptPreviewFileListPanelHeader = (props: { nameValue: string, dateValue: string, className?: string }) => {
  const { nameValue, dateValue, className } = props || {}
  const classes = useStyles()
  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.cell}>
        <span className={classes.label}>{lang.generics.name}</span>
        <p className={classes.text}>{nameValue}</p>
      </div>
      <div className={classes.cell}>
        <span className={classes.label}>{lang.generics.date}</span>
        <p className={classes.text}>{dateAsReadable(dateValue)}</p>
      </div>
    </div>
  )
}

export default RecieptPreviewFileListPanelHeader
